import './App.css';
import Home from './components/Home';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import TokenPage from './pages/TokenPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/map" element={<TokenPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
